module.exports = __webpack_public_path__ + "static/media/prestador.14d79e8e.jpg";